export default "__VITE_ASSET__DDMpf3k9__"